import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import persistState from 'redux-localstorage';
// import createHistory from 'history/createBrowserHistory';
import { createBrowserHistory } from "history";
import thunk from 'redux-thunk';
import { pick } from 'lodash';

import { initialState as authInitState } from './auth';
import { initialState as commonInitState } from './common';
import * as middlewares from './middlewares';

import rootReducer from './reducer';

export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL || '/'
});

const initState = {};
const enhancers = [
  persistState(undefined, {
    key: process.env.REACT_APP_NAME,
    slicer: (paths) => (state) => {
      // filter which substore to persist
      const subset = {
        auth: {
          ...authInitState,
          ...pick(state.auth, ['currentUser', 'token', 'env'])
        },
        common: {
          ...commonInitState,
          ...pick(
            state.common,
            ['location',
              'showError',
              'settings',
              "sound"]
          )
        }
      };
      return subset;
    }
  })
];
const middleware = [
  middlewares.handleGlobalError,
  thunk,
  routerMiddleware(history)
];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  initState,
  composeEnhancers(applyMiddleware(...middleware), ...enhancers)
);

export default store;
